import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=59173b70&"
import script from "./ArticleForm.vue?vue&type=script&lang=js&"
export * from "./ArticleForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleForm.vue?vue&type=style&index=0&id=59173b70&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports